export default {
  // Evaluation
  api_r_user_module_globalLegalCompliance_evaluation_loadLayout: {
    path: 'm/global-legal-compliance/evaluation/load-layout/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getPermissions: {
    path: 'm/global-legal-compliance/evaluation/get-permissions/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_loadObligations: {
    path: 'm/global-legal-compliance/evaluation/load-obligations/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_generateFilterHexCode: {
    path: 'm/global-legal-compliance/evaluation/generate-filter-hex-code/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getFilters: {
    path: 'm/global-legal-compliance/evaluation/get-filters/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_loadOLevel: {
    path: 'm/global-legal-compliance/evaluation/load-oLevel/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_changeState: {
    path: 'm/global-legal-compliance/evaluation/change-state/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_changeSecondState: {
    path: 'm/global-legal-compliance/evaluation/change-second-state/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_changeGoalState: {
    path: 'm/global-legal-compliance/evaluation/change-goal-state/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_changeProbSev: {
    path: 'm/global-legal-compliance/evaluation/change-prob-sev/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_changeLastVerification: {
    path: 'm/global-legal-compliance/evaluation/change-last-verification/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getStateHistory: {
    path: 'm/global-legal-compliance/evaluation/get-state-history/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_setFavouriteObligation: {
    path: 'm/global-legal-compliance/evaluation/set-favourite-obligation/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_setMaintenanceChecked: {
    path: 'm/global-legal-compliance/evaluation/set-maintenance-check/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_setUserMarkObligation: {
    path: 'm/global-legal-compliance/evaluation/set-user-mark-obligation/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_tab_legal: {
    path: 'm/global-legal-compliance/evaluation/tabs/legal/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_tab_legal_downloadLawFile: {
    path: 'm/global-legal-compliance/evaluation/tabs/legal/download-law-file/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_tab_sanction: {
    path: 'm/global-legal-compliance/evaluation/tabs/sanction/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getNavbarInfo: {
    path: 'm/global-legal-compliance/evaluation/get-navbar-info/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_tab_plantList: {
    path: 'm/global-legal-compliance/evaluation/tabs/plant-list/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_tab_information: {
    path: 'm/global-legal-compliance/evaluation/tabs/information/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_plant_permissions_get: {
    path: 'm/global-legal-compliance/evaluation/plant/permissions/get/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_plant_massive_edit: {
    path: 'm/global-legal-compliance/evaluation/plant/massive/edit/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getPlantManagers: {
    path: 'm/global-legal-compliance/evaluation/get-plant-managers/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_setPlantManagers: {
    path: 'm/global-legal-compliance/evaluation/set-plant-managers/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getCategories: {
    path: 'm/global-legal-compliance/evaluation/get-categories/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getCategoryGroups: {
    path: 'm/global-legal-compliance/evaluation/get-category-groups/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getNotes: {
    path: 'm/global-legal-compliance/evaluation/get-notes/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getObligationAssociations: {
    path: 'm/global-legal-compliance/evaluation/get-obligation-associations/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getResponsibles: {
    path: 'm/global-legal-compliance/evaluation/get-responsibles/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_getObligationGroups: {
    path: 'm/global-legal-compliance/evaluation/get-obligation-groups/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_setSingleState: {
    path: 'm/global-legal-compliance/evaluation/set-single-state/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_toggleSingleCorporateObligation: {
    path:
      'm/global-legal-compliance/evaluation/toggle-single-corporate-obligation/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_goToObligation: {
    path: 'm/global-legal-compliance/evaluation/go-to-obligation/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_obligationAssociation_toggle: {
    path: 'm/global-legal-compliance/evaluation/toggle-obligationAssociation/',
  },
  // Year Calendar
  api_r_user_module_globalLegalCompliance_yearCalendar_getInfo: {
    path: 'm/global-legal-compliance/year-calendar/get-info/',
  },
  api_r_user_module_globalLegalCompliance_yearCalendar_generateFilterHexCode: {
    path: 'm/global-legal-compliance/year-calendar/generate-filter-hex-code/',
  },
  api_r_user_module_globalLegalCompliance_yearCalendar_downloadXls: {
    path: 'm/global-legal-compliance/year-calendar/download-xls/',
  },
  // Responsible
  api_r_user_module_globalLegalCompliance_evaluation_responsible_list: {
    path: 'm/global-legal-compliance/evaluation/responsible/list/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_responsible_selected_list: {
    path: 'm/global-legal-compliance/evaluation/responsible/selected/list/',
  },
  api_r_user_module_globalLegalCompliance_evaluation_responsible_edit: {
    path: 'm/global-legal-compliance/evaluation/responsible/edit/',
  },
  // Evidences
  api_r_user_module_globalLegalCompliance_evidences_list: {
    path: 'm/global-legal-compliance/evidences/list/',
  },
  api_r_user_module_globalLegalCompliance_evidences_download: {
    path: 'm/global-legal-compliance/evidences/download/',
  },
  api_r_user_module_globalLegalCompliance_evidences_upload: {
    path: 'm/global-legal-compliance/evidences/upload/',
  },
  api_r_user_module_globalLegalCompliance_evidences_edit: {
    path: 'm/global-legal-compliance/evidences/edit/',
  },
  api_r_user_module_globalLegalCompliance_evidences_remove: {
    path: 'm/global-legal-compliance/evidences/remove/',
  },
  api_r_user_module_globalLegalCompliance_evidences_removedHistory: {
    path: 'm/global-legal-compliance/evidences/removed-history/',
  },
  // Reports
  api_r_user_module_globalLegalCompliance_report_calculate: {
    path: 'm/global-legal-compliance/report/calculate/',
  },
  // Calendar
  api_r_user_module_globalLegalCompliance_calendar_add: {
    path: 'm/global-legal-compliance/calendar/add/',
  },
  // Import
  api_r_user_module_globalLegalCompliance_import_downloadWorkXls: {
    path: 'm/global-legal-compliance/import/download-work-xls/',
  },
  api_r_user_module_globalLegalCompliance_import_uploadWorkXls: {
    path: 'm/global-legal-compliance/import/upload-work-xls/',
  },
  api_r_user_module_globalLegalCompliance_import_importWorkXls: {
    path: 'm/global-legal-compliance/import/import-work-xls/',
  },
};
